import { render, staticRenderFns } from "./nawi_repeatability.vue?vue&type=template&id=136eb994&"
import script from "./nawi_repeatability.vue?vue&type=script&lang=js&"
export * from "./nawi_repeatability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports